import { render } from "./AddPayrollGlobalDeductionRule.vue?vue&type=template&id=27fb74fa&scoped=true"
import script from "./AddPayrollGlobalDeductionRule.vue?vue&type=script&lang=js"
export * from "./AddPayrollGlobalDeductionRule.vue?vue&type=script&lang=js"

import "./AddPayrollGlobalDeductionRule.vue?vue&type=style&index=0&id=27fb74fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fb74fa"]])

export default __exports__